import { render, staticRenderFns } from "./GStudentImport.vue?vue&type=template&id=55ae01b9&scoped=true&"
import script from "./GStudentImport.vue?vue&type=script&lang=ts&"
export * from "./GStudentImport.vue?vue&type=script&lang=ts&"
import style0 from "./GStudentImport.vue?vue&type=style&index=0&id=55ae01b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ae01b9",
  null
  
)

export default component.exports